
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStagePrzesunZadanieOprawa(draggedId,targetId,refreshGantAll) {

// id = procesor id
console.log("dropStagePrzesunZadanieOprawa")
  
  axios
  .get(IP + "API_0009_gant_procedura_przesun_zadanie_oprawa/"+draggedId+"/"+targetId+"/"+ sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })
}


